
import type {PropType} from 'vue';
import {defineComponent} from 'vue';
import type MenuItem from './types';
// import usei18n from '@/composables/usei18n';
import usei18n from '../../util/theme_composable/usei18n';
import MainMenuItem from './MainMenuItem.vue';
// import Icon from '@/components/Icon/Icon.vue';
import Icon from '../Icon/Icon.vue';
// import Input from '@/components/Input/Input.vue';
import Input from '../Input/Input.vue';
// import IconButton from '@/components/Button/Icon.vue';
import IconButton from '../Button/Icon.vue';

export default defineComponent({
  name: 'OxdMainMenu', 

  components: {
    // 'oxd-icon': Icon,
    // 'oxd-input': Input,
    'oxd-icon-button': IconButton,
    'oxd-main-menu-item': MainMenuItem,
  },

  props: {
    url: {
      type: String,
      required: false,
      default: '/',
    },
    toggle: {
      type: Boolean,
      required: false,
      default: false,
    },
    menuItems: {
      type: Array as PropType<MenuItem[]>,
      required: false,
      default: () => [],
    },
  },

  emits: ['collapse'],

  setup() {
    return {
      ...usei18n(),
    };
  },

  data() {
    return {
      searchTerm: '',
    };
  },

  computed: {
    classes(): object {
      return {
        toggled: this.toggle,
      };
    },
    filteredMenuItems(): MenuItem[] {
      const escapedSearchTerm = this.searchTerm.replace(
        /[/\-\\^$*+?.()|[\]{}]/g,
        '\\$&',
      );
      const filter = new RegExp(escapedSearchTerm, 'i');
      return this.menuItems.filter((item) => item.name.match(filter));
    },
  },

  methods: {
    onClickCollapse() {
      this.$emit('collapse');
      // trigger resize event for body resize event listners
      // timeout delay is added for sidebar animation 0.3s
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 350);
    },
  },
});
